(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentWorkItemActionDialogController', DocumentWorkItemActionDialogController);

    DocumentWorkItemActionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'DocumentWorkItemAction', 'DocumentWorkItem'];

    function DocumentWorkItemActionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, DocumentWorkItemAction, DocumentWorkItem) {
        var vm = this;

        vm.documentWorkItemAction = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.documentworkitems = DocumentWorkItem.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documentWorkItemAction.id !== null) {
                DocumentWorkItemAction.update(vm.documentWorkItemAction, onSaveSuccess, onSaveError);
            } else {
                DocumentWorkItemAction.save(vm.documentWorkItemAction, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:documentWorkItemActionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        vm.setImageData = function ($file, documentWorkItemAction) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documentWorkItemAction.imageData = base64Data;
                        documentWorkItemAction.imageDataContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
